<template>
<div class="chapter">
<div class="inner_page">
<div epub:type="cover" id="cover">
<img alt="The Secret" class="cover-image" role="doc-cover" src="images/the-secret.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?166af277